import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockImageTag = _resolveComponent("StockImageTag")!

  return (_ctx.stock)
    ? (_openBlock(), _createBlock(_component_StockImageTag, {
        key: 0,
        isPostTicker: true,
        disableRouting: false,
        stockId: _ctx.stock._id,
        imgUrl: _ctx.stock.logoUrl,
        symbol: _ctx.stock.symbol,
        market: _ctx.stock.type
      }, null, 8, ["stockId", "imgUrl", "symbol", "market"]))
    : _createCommentVNode("", true)
}